import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton, Tooltip } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditProcessModal from './Edit-process-model';
import dayjs from 'dayjs';
import Table, { TableHook } from '../../Table';
import { ResponsiveActionBox } from '../../Table/mobileTable';
import { downloadFile } from '../../../services/api';

const url = '/process_data/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const generateDocument = async (setLoader, path, url) => {
    setLoader(true)
    if (path)
        downloadFile(url + '/')
    else
        window.open(url)
    
    setLoader(false)
}

const columns = (setState, permissions, setLoader) => {
    return [
        { field: 'process', headerName: 'Processo', flex: 1, filterType: 'string', renderCell: ({row, value}) => (<Box sx={{cursor: 'pointer'}} id={`link-for-process${row.id}`} onClick={()=> generateDocument(setLoader, row.internal_path, row.internal_url)} >{value}</Box>) },
        { field: 'foro', headerName: 'Foro', flex: 1, filterType: 'string' },
        { field: 'recebidoem', headerName: 'Recebido em', flex: 1, filterType: 'string' },
        { field: 'unidade', headerName: 'Unidade', flex: 1, filterType: 'string' },
        { field: 'reu', headerName: 'Réu', flex: 1, filterType: 'string' },
        { field: 'autor', headerName: 'Autor', flex: 1, filterType: 'string' },
        { field: 'endereco_loja', headerName: 'Endereço Loja', flex: 1, filterType: 'string' },
        { field: 'cidade', headerName: 'cidade', flex: 1, filterType: 'string' },
        { field: 'bairro', headerName: 'bairro', flex: 1, filterType: 'string' },
        { field: 'estado', headerName: 'estado', flex: 1, filterType: 'string' },
        {
            field: 'created_at', headerName: 'Data de criação', flex: 1, filterType: 'daterange',
            valueGetter: ({ value }) => dayjs(value).toDate().toLocaleString()
        },
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <ResponsiveActionBox >
                        {permissions.change_processdata && <Tooltip title='Editar processo'>
                            <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>
                        </Tooltip>}
                        {permissions.delete_processdata && <Tooltip title='Excluir processo'>
                            <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>
                        </Tooltip>}
                    </ResponsiveActionBox>
                )
            }
        }
    ]
}

export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver processos')
        return
    }
    const requests = [
        api.get('/permissions/')
    ]
    const [permissions] = await Promise.all(requests)
    const result = {}
    if (permissions.status === 200)
        result.permissions = permissions.data.results
    setState({ ...result })
}

const ProcessData = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        permissions: [],
        editRow: null,
        deleteRow: null
    })

    useEffect(() => {
        loadData(setState, user.permissions.view_processdata, setLoader)
    }, [setLoader, user.permissions.view_processdata])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, user.permissions.view_processdata, setLoader)
        reloadTable()
    }

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o processo? ${state.deleteRow.process}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditProcessModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    permissions={state.permissions}
                />
            }
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(()=> columns(setState, user.permissions, setLoader), [user.permissions, setLoader])}
                        pagination
                        density='compact'
                        slots={{
                            returnComponent: ()=> window.backtobase(),
                            addComponent: user.permissions.add_processdata ? () => setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true,
                            importComponent: user.permissions.add_processdata,
                            exportComponent: user.permissions.add_processdata
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({'rows': rows})}
                        innerRef={table}
                        mobile={true}
                        mobileProps={
                            {
                                title:['name']
                            }
                        }
                    />
                </Box>
            </Box>
        </>
    )
}

export default ProcessData